import Checkbox from '@amzn/meridian/checkbox';
import Column from '@amzn/meridian/column';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import React from 'react';
import {
  setSelectedRegionTask,
  setSelectedRegionTasks,
} from 'src/store/adminConfigPageSlice/regionTasksPageSlice/regionTasksPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';
import Text from '@amzn/meridian/text';
import ControlGroup from '@amzn/meridian/control-group';
import Button from '@amzn/meridian/button';
import Tag from '@amzn/meridian/tag';
import { RegionTaskModification } from 'src/services/tasks/types';

const AssignModificationsModal = () => {
  const dispatch = useAppDispatch();
  const { selectedRegionTask, selectedRegionTasks } = useAppSelector((state) => state.regionTasksConfigPage);
  const modifications = useAppSelector((state) => state.modifications.modifications);

  const assignModifications = (modificationIds: number[]) => {
    const newModifications = modificationIds.reduce((acc, modificationId) => {
      const modification = modifications.find(({ id }) => id === modificationId);
      return modification
        ? [
            ...acc,
            {
              modificationId,
              name: modification.name,
              description: modification.description,
            },
          ]
        : acc;
    }, [] as RegionTaskModification[]);

    dispatch(
      setSelectedRegionTask({
        ...selectedRegionTask!,
        modifications: newModifications,
      }),
    );
  };

  const close = () => dispatch(setSelectedRegionTask(null));

  const apply = () => {
    dispatch(
      setSelectedRegionTasks(
        selectedRegionTasks.map((regionTask) =>
          selectedRegionTask && regionTask.taskId === selectedRegionTask.taskId && regionTask.taskId
            ? selectedRegionTask
            : regionTask,
        ),
      ),
    );
    close();
  };

  const clear = () => {
    dispatch(
      setSelectedRegionTask({
        ...selectedRegionTask!,
        modifications: [],
      }),
    );
  };

  const dismissTag = (modificationId: number) => {
    assignModifications(
      selectedRegionTask!.modifications.map((m) => m.modificationId).filter((mId) => mId !== modificationId),
    );
  };

  return (
    <Modal open={!!selectedRegionTask} title={`${selectedRegionTask?.label} Modifications`} onClose={close}>
      <Row alignmentHorizontal="justify">
        <Text>{selectedRegionTask?.modifications.length} active</Text>
        <Button type="link" onClick={clear}>
          Clear All
        </Button>
      </Row>
      <Row spacingInset={'none none 400 none'} wrap="down" maxWidth={'550px'} spacing={'300'}>
        {selectedRegionTask?.modifications.map(({ name, modificationId }) => (
          <Tag
            key={modificationId}
            data-testid="modification-tag"
            type="neutral"
            onClose={() => dismissTag(modificationId)}
          >
            {name}
          </Tag>
        ))}
      </Row>
      {!!selectedRegionTask && (
        <Column type="outline" overflowY="scroll" minWidth={'550px'} maxHeight={'400px'} spacingInset={'400'}>
          <ControlGroup
            value={selectedRegionTask.modifications.map(({ modificationId }) => modificationId)}
            onChange={assignModifications}
          >
            {modifications.map((modification) => (
              <Checkbox key={modification.id} value={modification.id}>
                {modification.name}
              </Checkbox>
            ))}
          </ControlGroup>
        </Column>
      )}
      <ModalFooter>
        <Row alignmentHorizontal="end">
          <Button type="secondary" onClick={close}>
            Cancel
          </Button>
          <Button type="primary" onClick={apply}>
            Apply
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default AssignModificationsModal;
